import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateCoordinate } from "../../../../store/reducers/pdfeditor/pdfCoordinatesSlice";

function FontFamilyBox({ coordinate }) {
  const { currVariable } = useSelector((state) => state.toolsModification);
  const dispatch = useDispatch();
  const handleFontFamilyChange = (value) => {
    console.log(value);
    dispatch(
      updateCoordinate({
        id: currVariable?.id || currVariable?.variable,
        newValue: { fontFamily: value },
      })
    );
  };
  return (
    <div style={{ position: "relative", left: "75px", width: "40px" }}>
      <select
        style={{ height: "40px", borderRadius: "5px" }}
        value={coordinate.fontFamily || "Georgia"}
        onChange={(event) => handleFontFamilyChange(event.target.value)}
      >
        <option value="Georgia">Georgia</option>
        {/* <option value="sans-serif">Sans-Serif</option>
        <option value="cursive">Cursive</option>
        <option value="Helvetica">Helvetica</option> */}
      </select>
    </div>
  );
}

export default FontFamilyBox;
